import {createApi,fetchBaseQuery} from "@reduxjs/toolkit/query/react";

const cryptoNewsHeaders ={
    'X-BingApis-SDK': 'true',
    'X-RapidAPI-Key': '1f7e3d5b0amsh1647d51dfb56d98p12c19cjsnf0d589f4f09d',
    'X-RapidAPI-Host': 'bing-news-search1.p.rapidapi.com'
}

const baseUrl = "https://bing-news-search1.p.rapidapi.com";

const createResquest = (url) => ({url, headers:cryptoNewsHeaders });

export const cryptoNewsApi = createApi({
    reducerPath: "cryptoNewsApi",
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder) => ({
        getCryptoNews: builder.query({
            query: ({newsCategory,count})=> createResquest(`/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`)
        })
    })
});


export const {
    useGetCryptoNewsQuery,
} = cryptoNewsApi;